import { Fragment } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { buildSections } from './utils/buildSections';
import FieldSection from './FieldSection';
const SolvencyDeclarationForm = ({ form, step, onSubmit, questionnaireForm, validateField, }) => {
    const { t } = useTranslation();
    const sections = buildSections(questionnaireForm, step, form.watch);
    return (<FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-6">
                {sections.map((section, index) => {
            const rootName = section.fields[0].name;
            return (<Fragment key={rootName}>
                            <FieldSection section={section} questionnaireForm={questionnaireForm} form={form} t={t} validateField={validateField}/>
                            {index < sections.length - 1 && <div className="border-b border-neutral-primary-initial"/>}
                        </Fragment>);
        })}
            </form>
        </FormProvider>);
};
export default SolvencyDeclarationForm;
